'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'cloud';
var width = 576;
var height = 512;
var aliases = [9729];
var unicode = 'f0c2';
var svgPathData = 'M96 176c0-79.5 64.5-144 144-144 55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96 0 15.7-3.8 30.6-10.5 43.7 44 20.3 74.5 64.7 74.5 116.3 0 70.7-57.3 128-128 128l-304 0C64.5 480 0 415.5 0 336 0 272.6 41 218.8 97.9 199.5 96.7 191.9 96 184 96 176zM240 48c-70.7 0-128 57.3-128 128 0 9.4 1 18.6 2.9 27.4 .9 4.1-1.6 8.3-5.7 9.4-53.8 15.1-93.3 64.6-93.3 123.2 0 70.7 57.3 128 128 128l304 0c61.9 0 112-50.1 112-112 0-48-30.2-89-72.8-104.9-2.3-.8-4-2.7-4.8-5s-.4-4.8 .9-6.8c8-12.5 12.7-27.3 12.7-43.2 0-44.2-35.8-80-80-80-17.6 0-33.8 5.7-47 15.2-2 1.4-4.4 1.9-6.8 1.3s-4.3-2.3-5.2-4.5c-19.9-44.8-64.8-76-117-76z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloud = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;